import React from 'react';
import { Container, Box, Grid, Typography } from '@material-ui/core';

const Wrapper = (props) => {
  if (props.boxWrapped) {
    return <Container>{props.children}</Container>;
  }
  return <div>{props.children}</div>;
};
const SearchDetails = (props) => {
  const { children, heading, isEmbed = false } = props;
  return (
    <Box my={1}>
      <Wrapper boxWrapped={!isEmbed}>
        <Grid
          container
          spacing={1}
          justify="center"
          // alignItems="center"
        >
          {children}
        </Grid>
      </Wrapper>
    </Box>
  );
};

export default SearchDetails;
